import React, { useContext, useEffect, useState } from "react";
import NewButton from "./NewButton";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as MEMBERADMIN } from "../assets/icons/MemberAdmin.svg";
import { ReactComponent as MEMBER } from "../assets/icons/Member.svg";
import { Check } from "react-feather";
import { FormTextInput } from "../Components/FormTextInput";
import { Info } from "react-feather";
import TeamDropdown from "../Screens/Account/OrdersComponents/TeamDropdown";
import { NotificationContext } from "../Context/NotificationContext";
import { firestore, getFullHttpUrl } from "../firebase.config";
import axios from "axios";
import { useEnterKey } from "../Hooks/useEnterKey";
import { get2DecimalNumber } from "../Data/Functions";


const memberOptions = [{name: "New Member", value: "new-member"}, {name: "Exisiting Member", value: "exisiting-member"}];
const memberRoleOptions = ["member", "admin"];
const expeditedOptions = [{name: "Paid", value: "paid"}, {name: "Free", value: "free"}, {name: "Free+", value: "free-plus"}];

const roleStatus = {
  member: "Can place/manage orders, invite users, and make payments.",
  admin: "Everything a Member can do, plus remove users, update payment methods, and change the payment approach.",
};

const CreateTeamPopUp = ({ onClose }) => {

  const { showNotification } = useContext(NotificationContext);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [teamName, setTeamName] = useState('');
  const [discount, setDiscount] = useState('');
  const [selectedExpedited, setSelectedExpedited] = useState(expeditedOptions[0].value);
  const [password, setPassword] = useState("");
  const [selectedMemberRole, setSelectedMemberRole] = useState('member');
  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);
  const [hoveredRole, setHoveredRole] = useState("");
  const [addMember, setAddMember] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [createBtn, setCreateBtn] = useState("Create Team");
  
 
  const roleIcons = {
    member: <MEMBER className="memberRoleIcon" />,
    admin: <MEMBERADMIN className="memberRoleIcon" />,
  };

  const [selectedMemberType, setSelectedMemberType] = useState(memberOptions[0].value);
   const [existingMembers, setExistingMembers] = useState([]);
  
   useEffect(() => {
      firestore.collection("users").get().then(async (snapshot) => {
        if(snapshot.empty){
          return;
        }
          try {
            const userData = snapshot.docs.map((userDoc) => {
                return { id: userDoc.id, ...userDoc.data() };
              })
      
            setExistingMembers(userData.filter(u => u.temaId ? false : true));
          } catch (error) {
            console.error("Error fetching teams: ", error);
            showNotification("Error", "Failed to fetch team user data", "error");
          }
        });
      
    }, [])

  const handleCreateTeam = async () => {
    if (!teamName.trim()) {
      showNotification("Error", "Team name is required.", "error");
      return;
    }
    if (parseInt(discount, 10) > 100) {
      showNotification("Error", "Discount is greater than 100.", "error");
      return;
    }
    if (addMember ) {
      if(selectedMemberType === memberOptions[0].value && (!email || !firstName || !password)){
        showNotification("Error", "Please fill all required fields except last name.", "error");
        return;
      }
      if(selectedMemberType === memberOptions[1].value && !selectedUser){
        showNotification("Error", "Please select a User.", "error");
        return;
      }
      
    }
    setCreateBtn("Creating...");

    try {
    //   const existingTeam = await firestore.collection("teams").where("name", "==", teamName.trim()).get();

    // if (!existingTeam.empty) {
    //   showNotification("Error", "A team with this name already exists. Please use a different name.", "error");
    //   return; 
    // }

      const teamRef = await firestore.collection("teams").add({
        name: teamName,
        // discount: discount === "" || !discount ? 0 : get2DecimalNumber(discount, 10),
        discount: discount === "" || !discount ? 0 : discount,
        expeditedServices: selectedExpedited,
        lastInvoiceTimestamp: new Date().getTime(),
        orderPlacedNotifyToAll: false,
        orderCompletedNotifyToAll: false,
        quotePlacedNotifyToAll: false,
        quoteReadyNotifyToAll: false,
        status:'Active',
        timestamp: new Date().getTime(),
        shipping: [],
        billingTerm : "case-by-case",
        billingPeriod: null,
      });

      if (addMember) {

        const data = selectedMemberType === memberOptions[0].value ? {
          teamId: teamRef.id,
          teamRole: selectedMemberRole,
          name: firstName + " " + lastName,
          firstName: firstName,
          lastName: lastName,
          email: email.toLowerCase(),
          password: password,
        } : {
          teamId: teamRef.id,
          teamRole: selectedMemberRole,
          userId: selectedUser.id,
          email: selectedUser.email,
        }

          await axios({
            method: "post",
            url: getFullHttpUrl("team-addMember"),
            data: {
              allDetails: data,
                existingUser: selectedMemberType === memberOptions[1].value && selectedUser ? true : false,
              },
          }).then(async (res) => {
              if(res.data.status === "member-updated"){
                return showNotification(
                  "Success", 
                  "Team Member added successfully.",
                  "success"
                );
              }
            });
      }
      showNotification("Success", "Team created successfully!", "success");
      onClose();
    } catch (error) {
      console.log(error);
      showNotification("Error", "Failed to create the team. Please try again.", "error");
    }finally{
      setCreateBtn("Create Team");
    }
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    setInvalidEmail(false);
  }

  const handleMouseOver = (role) => {
    setHoveredRole(role);
    setShowStatusHoverBox(true);
  };

  const handleMouseOut = () => {
    setShowStatusHoverBox(false);
    setHoveredRole("");
  };

  const onChangeDiscount = (discount) => {

    var reg = /^[0-9]+\.?[0-9]{0,3}$/;

    if (discount === "" || reg.test(discount)) {
      setDiscount(discount);
    }
  };

  useEnterKey(() => handleCreateTeam());
  

  return (
    <div className="newPopUpModalWrap">
      <div className="employeeUpdateModalContainer">
        <div className="employeeUpdateModalContainerScroll">
          <h2 className="newPopUpModalTitle">
            {"Create Team"}
          </h2>

          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Team</h4>

            <div className="quoteDetailsInputsContainer">
              <FormTextInput
                placeholder="Team Name"
                value={teamName}
                onChange={setTeamName}

              />
              <FormTextInput
                placeholder="Discount(%)"
                value={discount}
                onChange={onChangeDiscount}

              />
            </div>

          </div>
          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Expedited Service</h4>
            <div className="quoteDetailsInputsContainer">
              {expeditedOptions.map((option, i) => (
                <div
                  key={option + i}
                  className={`expeditedButton ${selectedExpedited === option.value ? "selected" : ""
                    }`}
                  onClick={() => setSelectedExpedited(option.value)}
                >
                  <p>{option.name}</p>
                </div>
              ))}
            </div>
          </div>
          {/* <div className="employeeDetailsInputsContainer"> */}
            <div className="hardCopyCheckboxLine">
              <div className={`${addMember ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
                <Check className="hardCopyCheck" onClick={() => { setAddMember(i => !i) }} style={{ opacity: addMember ? 1 : 0 }} />
              </div>
              <p className="hardCopyCheckboxText" onClick={() => { setAddMember(i => !i) }}>Add Member</p>
            </div>

          {/* </div> */}


          {addMember && <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Member</h4>
            <div className="expeditedTeamButton">
              {memberOptions.map((option, i) => (
                <div
                  key={option.value + i}
                  className={`memberButton ${selectedMemberType === option.value ? "selected" : ""
                    }`}
                  onClick={() => setSelectedMemberType(option.value)}
                >
                  <p>{option.name}</p>
                </div>
              ))}
            </div>

          </div>}

          {
            addMember && selectedMemberType === memberOptions[0].value &&
            <FormTextInput incorrect={invalidEmail} clearInputIcon={true} placeholder="Email" value={email} onChange={handleEmailChange} />
          } {addMember &&
            selectedMemberType === memberOptions[0].value &&
            <div className="quoteDetailsInputsContainer">
              <FormTextInput placeholder="First Name" value={firstName} onChange={setFirstName} />
              <FormTextInput placeholder="Last Name" value={lastName} onChange={setLastName} />
            </div>
          } {addMember &&
            selectedMemberType === memberOptions[0].value &&
            <FormTextInput
              placeholder="Password"
              value={password}
              onChange={setPassword}
              password
              showPasswordIcon
            />}
          {addMember &&
            selectedMemberType === memberOptions[1].value && 

            <TeamDropdown customClass={'selectTranslator'} icon={false}
              member={true}
              clients={existingMembers}
              onChange={(selectedUserData) => {
                setSelectedUser(selectedUserData);
              }} />
              
          }

          {addMember && <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Member Role</h4>
            <div className="quoteDetailsInputsContainer">
              {memberRoleOptions.map((option, i) => (
                <div
                  key={option + i}
                  className={`memberRoleButton ${selectedMemberRole === option ? "selected" : ""
                    }`}
                  onClick={() => setSelectedMemberRole(option)}
                >

                  <div className="memberOrderStatus">
                    {showStatusHoverBox && hoveredRole === option && (
                      <div className="teamStatusHover">
                        <p className="subTitle">{roleStatus[hoveredRole]}</p>
                      </div>
                    )}
                    {roleIcons[option]}
                    <p>{option}</p><Info className="statusIcon" onMouseOver={() => handleMouseOver(option)}
                      onMouseOut={handleMouseOut} /></div>
                </div>
              ))}
            </div>
          </div>}
          <div className="expeditedTeamButton">
            <NewButton text="Cancel" disabled={createBtn === "Creating..."} onClick={onClose} back={true} icon={false} whiteBtn={true}/>
            <NewButton text={createBtn} disabled={createBtn === "Creating..."} onClick={() => { handleCreateTeam() }} />
          </div>

          <Close className="newPopUpModalCloseIcon" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default CreateTeamPopUp;
